<script>
import CrudListVue from '@/app/arch/components/crud/CrudList.vue';
import AnalysisTableRequest from 'Modules/contacard/analysisTable/AnalysisTableRequest';
import DataTableClientTypeColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableClientTypeColumn.vue';
import DataTableCpfCnpjColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTableDateColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableDateColumn.vue';
import DataTableTelefoneColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableTelefoneColumn.vue';
import StorageMixin from 'Arch/mixins/StorageMixin';
import ClientRegisterStatusColumnVue from 'Modules/contacard/analysisTable/components/columns/ClientRegisterStatusColumn.vue';
import ClientAccessStatusColumnVue from 'Modules/contacard/analysisTable/components/columns/ClientAccessStatusColumn.vue';
import ClientUserAdminNameColumnVue from 'Modules/contacard/analysisTable/components/columns/ClientUserAdminNameColumn.vue';

export default {
  name: 'AnalysisTableList',
  extends: CrudListVue,
  mixins: [StorageMixin],
  data: () => ({
    requestClass: AnalysisTableRequest,
    hideDelete: true,
    editRoute: 'analysisTable.edit',
    headers: [
      {
        text: 'Razão social',
        value: 'nomCliente',
      },
      {
        text: 'Nome sócio admin',
        value: 'numTelefone',
        component: ClientUserAdminNameColumnVue,
      },
      {
        text: 'Tipo cliente',
        value: 'tipoCliente',
        component: DataTableClientTypeColumnVue,
      },
      {
        text: 'Documento',
        value: 'cpfCnpj',
        component: DataTableCpfCnpjColumnVue,
      },
      {
        text: 'Situação cadastral',
        value: 'situacaoCadastral',
        component: ClientRegisterStatusColumnVue,
      },
      {
        text: 'Situação de acesso',
        value: 'situacaoAcesso',
        component: ClientAccessStatusColumnVue,
      },
      {
        text: 'Nome da mãe',
        value: 'nomMae',
      },
      {
        text: 'Data de nascimento',
        value: 'datNascimento',
        component: DataTableDateColumnVue,
      },
      {
        text: 'E-mail',
        value: 'txtEmail',
      },
      {
        text: 'Telefone',
        value: 'numTelefone',
        component: DataTableTelefoneColumnVue,
      },
      {
        text: 'Data de criação',
        value: 'createdDate',
        component: DataTableDateColumnVue,
      },
      {
        text: 'Última atualização',
        value: 'updatedDate',
        component: DataTableDateColumnVue,
      },
    ],
  }),
  methods: {
    editAction(item) {
      this.saveClient(item);
      this.goTo(
        this.editRoute,
        {
          id: item.id,
        },
      );
    },
    saveClient(item) {
      this.storage.save(
        '@clientTable',
        item,
      );
    },
    prepareRequest(params = {}) {
      return this.requestClass.list({
        situacaoCadastral: 'EM_ANALISE,PENDENTE',
        ...params,
      });
    },
  },
};
</script>
